import React, { useState } from 'react';
import { useMsal } from "@azure/msal-react";
import { User, FileText, Briefcase, Award } from 'lucide-react';
import { SignOutRedirectButton } from './SignOutRedirectButton';
import PayslipDetail from './PayslipDetail';

const DashboardTile = ({ icon, title, description, color, onClick, disabled }) => {

   if (disabled) return null;
   
  const baseClasses = disabled
    ? 'bg-gray-200 rounded-xl shadow-inner p-6 flex flex-col items-center text-center opacity-50 cursor-not-allowed'
    : `bg-white rounded-xl shadow-md p-6 flex flex-col items-center text-center transition-all duration-300 hover:shadow-lg hover:-translate-y-1 cursor-pointer ${color}`;

  return (
    <div
      className={baseClasses}
      onClick={disabled ? undefined : onClick}
      aria-disabled={disabled}
    >
      {icon}
      <h3 className="mt-4 font-semibold text-lg text-gray-800">{title}</h3>
      <p className="mt-2 text-sm text-gray-600">{description}</p>
    </div>
  );
};

const EmployeePortal = () => {
  const [activeSection, setActiveSection] = useState('dashboard');
  const { accounts } = useMsal();
  const userName = accounts[0]?.name || "Neznámý uživatel";

  // Dynamicky určím, která sekce je povolená
  const isDisabled = (sectionKey) => sectionKey !== 'payslip';

  return (
    <div className="min-h-screen bg-gray-100">
      <nav className="bg-gray-100 text-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="flex flex-col sm:flex-row sm:items-center">
              <img
                src="/images/logo.png"
                alt="Logo"
                className="hidden sm:block h-20 w-30 mr-2 cursor-pointer"
                onClick={() => setActiveSection('dashboard')}
              />
              <span
                className="font-semibold text-xl sm:text-2xl text-gray-700 cursor-pointer"
                onClick={() => setActiveSection('dashboard')}
              >
                Portál zaměstnance
              </span>
            </div>
            <div className="flex items-center space-x-4">
              <div className="hidden sm:flex items-start">
                <User className="h-7 w-7 text-gray-700" />
                <div className="ml-4">
                  <h2 className="text-lg text-gray-600">{userName}</h2>
                </div>
              </div>
              <SignOutRedirectButton />
            </div>
          </div>
        </div>
      </nav>

      <main className="max-w-7xl mx-auto px-0 sm:px-6">
        {activeSection === 'dashboard' && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mx-4">
            <DashboardTile
              icon={<FileText size={40} className="text-blue-500" />}
              title="Výplatní lístek"
              description="Zobrazit a stáhnout výplatní lístky"
              color="hover:bg-blue-50"
              onClick={() => setActiveSection('payslip')}
              disabled={isDisabled('payslip')}
            />
            <DashboardTile
              icon={<Briefcase size={40} className="text-green-500" />}
              title="Cestovní příkazy"
              description="Správa a vyúčtování služebních cest"
              color=""
              onClick={() => {}}
              disabled={isDisabled('travel')}
            />
            <DashboardTile
              icon={<Award size={40} className="text-yellow-500" />}
              title="Odměny"
              description="Přehled získaných odměn a bonusů"
              color=""
              onClick={() => {}}
              disabled={isDisabled('rewards')}
            />
            <DashboardTile
              icon={<User size={40} className="text-purple-500" />}
              title="Osobní údaje"
              description="Aktualizace osobních informací"
              color=""
              onClick={() => {}}
              disabled={isDisabled('profile')}
            />
          </div>
        )}

        {activeSection === 'payslip' && (
          <PayslipDetail onBack={() => setActiveSection('dashboard')} />
        )}
      </main>
    </div>
  );
};

export default EmployeePortal;
